import { set, toggle } from '@/utils/vuex'
export default {
  progress: set('progress'),
  alert(state, data) {
    state.alert = data
  },
  progress(state,show){
    state.progress=show;
  },
  userDetail(state,data){
    state.userDetail=data;
  }
}
